/* BEZELOR product photo viewer: one photo at a time, arrows, counter, thumbnail strip, swipe and keyboard.
   It sits on top of the theme's product-modal (which still opens, closes and picks the first photo). */
(() => {
  const init = (modal) => {
    if (modal.dataset.bzv) return;
    modal.dataset.bzv = '1';
    const dialog = modal.querySelector('.product-media-modal__dialog');
    const content = modal.querySelector('.product-media-modal__content');
    const prev = modal.querySelector('.bzv__nav--prev');
    const next = modal.querySelector('.bzv__nav--next');
    const count = modal.querySelector('.bzv__count');
    const strip = modal.querySelector('.bzv__thumbs');
    if (!dialog || !content || !strip) return;

    let items = [];
    let built = false;

    /* A photo item is the <img> itself; a video or 3D item is a wrapper with a poster picture inside */
    const pic = (el) => (el.tagName === 'IMG' ? el : el.querySelector('img'));
    const small = (url) => (url || '').replace(/([?&])width=\d+/, '$1width=160').replace(/&height=\d+/, '');
    const firstSrc = (img) => {
      if (!img) return '';
      const attr = img.getAttribute('src');
      if (attr) return attr;
      const set = img.getAttribute('srcset') || '';
      return set.split(',')[0].trim().split(' ')[0];
    };

    const collect = () => {
      items = [...content.children].filter((el, i) => el.hasAttribute('data-media-id') && (!el.classList.contains('product__media-item--variant') || i === 0));
    };
    const current = () => Math.max(0, items.findIndex((el) => el.classList.contains('active')));

    const build = () => {
      collect();
      strip.textContent = '';
      items.forEach((el, i) => {
        const b = document.createElement('button');
        b.type = 'button';
        b.className = 'bzv__thumb';
        b.setAttribute('aria-label', 'Photo ' + (i + 1));
        const url = small(firstSrc(pic(el)));
        if (url) {
          const t = document.createElement('img');
          t.src = url;
          t.alt = '';
          t.decoding = 'async';
          b.appendChild(t);
        }
        b.addEventListener('click', () => go(i));
        strip.appendChild(b);
      });
      built = true;
    };

    /* Hidden photos never load while they are lazy; load the one shown and its neighbours */
    const warm = (n) => {
      [n - 1, n, n + 1].forEach((k) => {
        const el = items[(k + items.length) % items.length];
        const img = el && pic(el);
        if (img && img.loading === 'lazy') img.loading = 'eager';
      });
    };

    const sync = () => {
      const i = current();
      warm(i);
      if (count) count.textContent = (i + 1) + ' / ' + items.length;
      [...strip.children].forEach((b, n) => {
        const on = n === i;
        b.classList.toggle('is-on', on);
        if (on) b.setAttribute('aria-current', 'true'); else b.removeAttribute('aria-current');
        if (on) { const x = b.offsetLeft - (strip.clientWidth - b.clientWidth) / 2; strip.scrollTo({ left: x, behavior: 'smooth' }); }
      });
      const single = items.length < 2;
      modal.classList.toggle('bzv--single', single);
      if (prev) prev.disabled = single;
      if (next) next.disabled = single;
    };

    const go = (n) => {
      if (!items.length) return;
      n = (n + items.length) % items.length;
      items.forEach((el, i) => el.classList.toggle('active', i === n));
      const el = items[n];
      if (el.nodeName === 'DEFERRED-MEDIA' && typeof el.loadContent === 'function' && !el.querySelector('video, iframe, model-viewer')) { try { el.loadContent(); } catch (e) {} }
      if (typeof window.pauseAllMedia === 'function') window.pauseAllMedia();
      sync();
    };

    const onOpen = () => {
      if (!built) build();
      requestAnimationFrame(() => requestAnimationFrame(() => {
        if (!items.some((el) => el.classList.contains('active')) && items[0]) items[0].classList.add('active');
        sync();
        if (dialog.focus) dialog.focus({ preventScroll: true });
      }));
    };

    new MutationObserver(() => { if (modal.hasAttribute('open')) onOpen(); }).observe(modal, { attributes: true, attributeFilter: ['open'] });
    if (modal.hasAttribute('open')) onOpen();

    /* The theme closes the viewer on any mouse click that is not on a video; the controls must not do that */
    modal.querySelectorAll('.bzv__nav, .bzv__thumbs, .bzv__count').forEach((el) => el.addEventListener('pointerup', (e) => e.stopPropagation()));
    if (prev) prev.addEventListener('click', () => go(current() - 1));
    if (next) next.addEventListener('click', () => go(current() + 1));
    modal.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(current() - 1); }
      else if (e.key === 'ArrowRight') { e.preventDefault(); go(current() + 1); }
    });

    /* Swipe on touch screens */
    let x0 = null, y0 = 0;
    content.addEventListener('touchstart', (e) => { const t = e.touches[0]; x0 = t.clientX; y0 = t.clientY; }, { passive: true });
    content.addEventListener('touchend', (e) => {
      if (x0 === null) return;
      const t = e.changedTouches[0], dx = t.clientX - x0, dy = t.clientY - y0;
      x0 = null;
      if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.3) go(current() + (dx < 0 ? 1 : -1));
    }, { passive: true });
  };

  const run = () => document.querySelectorAll('product-modal').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  document.addEventListener('shopify:section:load', run);
  /* product-modal moves itself to <body> when it connects, so also look again shortly after load */
  window.addEventListener('load', () => setTimeout(run, 50));
})();
